export const APP_LOCALE = "pt-PT";
export const APP_CURRENCY = "EUR";
